import React from "react"
import { Icon } from "antd"
import API from "../../data/trajectory"
import Panel from "./components/panel"
import "./index.scss"
const echarts = window.echarts

var vdata = []
var geoCoordMap = {}
var convertData = function(data) {
  var res = []
  for (var i = 0; i < data.length; i++) {
    var geoCoord = geoCoordMap[data[i].name]
    if (geoCoord) {
      res.push({
        name: data[i].name,
        value: geoCoord.concat(data[i].value),
      })
    }
  }
  return res
}
var polygon = []

function renderItem(params, api) {
  var coords = polygon
  var points = []
  for (var i = 0; i < coords.length; i++) {
    points.push(api.coord(coords[i]))
  }
  var color = "#FF8080"
  return {
    type: "polygon",
    shape: {
      points: echarts.graphic.clipPointsByRect(points, {
        x: params.coordSys.x,
        y: params.coordSys.y,
        width: params.coordSys.width,
        height: params.coordSys.height,
      }),
    },
    style: api.style({
      fill: color,
      stroke: "#FFF",
      lineWidth: 2,
    }),
  }
}

function unique(array) {
  /**
     对数组中的经纬度一样的进行去重
     **/
  var r = []
  for (var i = 0, l = array.length; i < l; i++) {
    for (var j = i + 1; j < l; j++)
      if (
        array[i]["value"][0] === array[j]["value"][0] &&
        array[i]["value"][1] === array[j]["value"][1]
      ) {
        j = ++i
        continue
      }
    r.push(array[i])
  }
  return r
}
let ser_data = []
class Trajectory extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}
    ser_data = []
    vdata = [] //{name:'永安小区',value:200}
    geoCoordMap = {}
    polygon = []
  }

  componentDidMount() {
    // return
    var dom = this.refs.$map
    this.myChart = echarts.init(dom)
    this.requestTra()
  }
  requestTra() {
    let me = this
    let myChart = this.myChart
    API.getWeekTra().then(data => {
      var busLines = [].concat.apply(
        [],
        data.map(function(busLine, idx) {
          var prevPt = []
          var points = []
          for (var i = 0; i < busLine.length; i += 2) {
            var pt = [busLine[i], busLine[i + 1]]
            if (i > 0) {
              pt = [prevPt[0] + pt[0], prevPt[1] + pt[1]]
            }
            prevPt = pt

            points.push([pt[0] / 1e4, pt[1] / 1e4])
          }
          return {
            coords: points,
          }
        })
      )

      let option = {
        tooltip: {
          trigger: "item",
        },
        bmap: {
          center: [121.38, 31.13],
          zoom: 12,
          roam: true,
          mapStyle: {
            styleJson: [
              {
                featureType: "water",
                elementType: "all",
                stylers: {
                  color: "#031628",
                },
              },
              {
                featureType: "land",
                elementType: "geometry",
                stylers: {
                  color: "#000102",
                },
              },
              {
                featureType: "highway",
                elementType: "all",
                stylers: {
                  visibility: "off",
                },
              },
              {
                featureType: "arterial",
                elementType: "geometry.fill",
                stylers: {
                  color: "#000000",
                },
              },
              {
                featureType: "arterial",
                elementType: "geometry.stroke",
                stylers: {
                  color: "#0b3d51",
                },
              },
              {
                featureType: "local",
                elementType: "geometry",
                stylers: {
                  color: "#000000",
                },
              },
              {
                featureType: "railway",
                elementType: "geometry.fill",
                stylers: {
                  color: "#000000",
                },
              },
              {
                featureType: "railway",
                elementType: "geometry.stroke",
                stylers: {
                  color: "#08304b",
                },
              },
              {
                featureType: "subway",
                elementType: "geometry",
                stylers: {
                  lightness: -70,
                },
              },
              {
                featureType: "building",
                elementType: "geometry.fill",
                stylers: {
                  color: "#000000",
                },
              },
              {
                featureType: "all",
                elementType: "labels.text.fill",
                stylers: {
                  color: "#857f7f",
                  // 'visibility': 'off'
                },
              },
              {
                featureType: "all",
                elementType: "labels.text.stroke",
                stylers: {
                  color: "#000000",
                  // 'visibility': 'off'
                },
              },
              {
                featureType: "building",
                elementType: "geometry",
                stylers: {
                  color: "#022338",
                },
              },
              {
                featureType: "green",
                elementType: "geometry",
                stylers: {
                  color: "#062032",
                },
              },
              {
                featureType: "boundary",
                elementType: "all",
                stylers: {
                  color: "#465b6c",
                },
              },
              {
                featureType: "manmade",
                elementType: "all",
                stylers: {
                  color: "#022338",
                  visibility: "off",
                },
              },
              {
                featureType: "label",
                elementType: "all",
                stylers: {
                  visibility: "off",
                },
              },
              // {
              //   "featureType": "poi",
              //   "elementType": "all",
              //   "stylers": {
              //     "visibility": "off"
              //   }
              // }
            ],
          },
        },
        series: [
          {
            type: "lines",
            coordinateSystem: "bmap",
            polyline: true,
            data: busLines,
            silent: true,
            lineStyle: {
              normal: {
                width: 3,
                color: function(params) {
                  var dataIndex = params.dataIndex
                  switch (dataIndex) {
                    case 0:
                      return "#90893c"
                    case 1:
                      return "#90428b"
                    case 2:
                      return "#509051"
                    case 3:
                      return "#90663e"
                    case 4:
                      return "#2aa7e1"
                    case 5:
                      return "#8a5f89"
                    case 6:
                      return "#903d3d"
                    default:
                      return "#90893c"
                  }
                },
              },
            },
            progressiveThreshold: 500,
            progressive: 200,
          },
          {
            type: "lines",
            coordinateSystem: "bmap",
            polyline: true,
            data: [busLines[0]],
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            effect: {
              constantSpeed: 20,
              show: true,
              trailLength: 0,
              symbolSize: [26 / 2, 52 / 2],
              symbol: "image://img/Monday.png",
            },
            zlevel: 1,
          },
          {
            type: "lines",
            coordinateSystem: "bmap",
            polyline: true,
            data: [busLines[1]],
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            effect: {
              constantSpeed: 18,
              show: true,
              trailLength: 0,
              symbolSize: [26 / 2, 52 / 2],
              symbol: "image://img/Tuesday.png",
            },
            zlevel: 1,
          },
          {
            type: "lines",
            coordinateSystem: "bmap",
            polyline: true,
            data: [busLines[2]],
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            effect: {
              constantSpeed: 17,
              show: true,
              trailLength: 0,
              symbolSize: [26 / 2, 52 / 2],
              symbol: "image://img/Wednesday.png",
            },
            zlevel: 1,
          },
          {
            type: "lines",
            coordinateSystem: "bmap",
            polyline: true,
            data: [busLines[3]],
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            effect: {
              constantSpeed: 16,
              show: true,
              trailLength: 0,
              symbolSize: [26 / 2, 52 / 2],
              symbol: "image://img/Thursday.png",
            },
            zlevel: 1,
          },
          {
            type: "lines",
            coordinateSystem: "bmap",
            polyline: true,
            data: [busLines[4]],
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            effect: {
              constantSpeed: 15,
              show: true,
              trailLength: 0,
              symbolSize: [26 / 2, 52 / 2],
              symbol: "image://img/Friday.png",
            },
            zlevel: 1,
          },
          {
            type: "lines",
            coordinateSystem: "bmap",
            polyline: true,
            data: [busLines[5]],
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            effect: {
              constantSpeed: 14,
              show: true,
              trailLength: 0,
              symbolSize: [26 / 2, 52 / 2],
              symbol: "image://img/Saturday.png",
            },
            zlevel: 1,
          },
          {
            type: "lines",
            coordinateSystem: "bmap",
            polyline: true,
            data: [busLines[6]],
            lineStyle: {
              normal: {
                width: 0,
              },
            },
            effect: {
              constantSpeed: 13,
              show: true,
              trailLength: 0,
              symbolSize: [26 / 2, 52 / 2],
              symbol: "image://img/Sunday.png",
            },
            zlevel: 1,
          },
          {
            type: "effectScatter",
            coordinateSystem: "bmap",
            data: convertData(vdata),
            symbolSize: 10,
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
            },
            hoverAnimation: false,
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: true,
              },
            },
            itemStyle: {
              normal: {
                color: "#f4e925",
                shadowBlur: 10,
                shadowColor: "#333",
              },
            },
            zlevel: 5,
          },
          {
            type: "custom",
            coordinateSystem: "bmap",
            renderItem: renderItem,
            itemStyle: {
              normal: {
                opacity: 0.7,
              },
            },
            animation: false,
            silent: true,
            data: [0],
            z: -10,
          },
        ],
      }
      myChart.setOption(option)

      var ecModel = myChart._model
      let bmap
      ecModel.eachComponent("bmap", function(bmapModel) {
        if (!bmap) {
          bmap = bmapModel.getBMap()
          bmap.setMapType(window.BMAP_NORMAL_MAP)
        }
      })
      myChart.on("click", function(params) {
        if (params && params.seriesType === "lines") {
          let idx = params.seriesIndex - 1
          let url =
            // "http://127.0.0.1:5000/video?index=" +
            "https://ecar.newayz.com/video?index=" +
            idx +
            "&sign=95bba907e660472bac5054d454a2a4f3"
          // VIDEO.play(url)
          me.setState({ url })
        }
      })
    })
  }
  onClickPoi = poi => {
    let myChart = this.myChart
    if (ser_data.length > 0) {
      ser_data = []
    }

    polygon = poi["polygon"] || []
    vdata.push({
      name: poi["name"],
      value: poi["value"],
    })

    vdata = unique(vdata)

    geoCoordMap[poi["name"]] = [poi["lon"], poi["lat"]]
    if (!myChart) {
      return
    }
    var option = myChart.getOption()
    ser_data = ser_data.concat(convertData(vdata))
    ser_data = unique(ser_data)
    option.series[8].data = ser_data
    option.bmap[0].center = [poi["lon"], poi["lat"]]
    option.bmap[0].zoom = 14
    //更新数据
    myChart.setOption(option)
    vdata = []
    geoCoordMap = {}
    this.setState({ curPoi: poi })
  }
  render() {
    let { curPoi, url } = this.state
    let { onCloseModal } = this.props
    return (
      <div className="page p-tra">
        <div className="page-inner">
          <div className="header">
            <Icon type="left" onClick={onCloseModal} />
            <div>用户轨迹</div>
          </div>
          <div className="content">
            <div className="map-container" ref="$map" />
            <Panel curPoi={curPoi} onClick={this.onClickPoi} />
            {url ? (
              <div
                className="videoCon"
                onClick={() => {
                  this.setState({ url: null })
                }}
              >
                <p>点击或按Esc键退出播放</p>
                <video autoPlay src={url} />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    )
  }
}

export default Trajectory
